import { debounce } from 'lodash';

export default {
    data: () => ({
        scrollToTop: false,
    }),

    methods: {
        scrollTop() {
            this.$nextTick(() => {
                this.scrollToTop = true;
                this.$refs.stickyScroll.scrollTop = 0;
            });
        },

        stickyScroll(force) {
            if (this.scrollToTop) {
                this.scrollToTop = false;
                return;
            }

            let $ref = this.$refs.stickyScroll;
            let isAtBottom = $ref.scrollHeight - $ref.clientHeight <= $ref.scrollTop + 1;

            if (isAtBottom || force) {
                this.$nextTick(() => {
                    $ref.scrollTop = $ref.scrollHeight - $ref.clientHeight;
                });
            }
        },

        stickyScrollActiveMessage({ delay = 0 } = {}) {
            this.$nextTick(async () => {
                await this.$delay(delay);

                if (!this.$route.query.messageId) return;

                const messagesWrapper = this.$refs.stickyScroll;
                const messageElement = document.querySelector(`.conversation-message-${this.$route.query.messageId}`);
                const offsetTop = messageElement?.offsetTop;
                const clientHeight = messageElement?.clientHeight;

                messagesWrapper.scrollTop = (offsetTop - messagesWrapper.clientHeight / 2) + (clientHeight / 2);
                this.debounceHandleActiveMessageRedirectTo(`/conversations/${this.conversation.id}`);
            });
        },

        handleActiveMessageRedirectTo(path) {
            this.$router.replace(path);
        },
    },

    created() {
        this.debounceHandleActiveMessageRedirectTo = debounce(this.handleActiveMessageRedirectTo, 1000);
    },
};
